export type Route = string

export class Routes {
  static readonly MARKETING_WEBSITE = import.meta.env.VITE_MARKETING_WEBSITE
  static readonly LOGIN_ROUTE = import.meta.env.VITE_LOGIN_ROUTE
  static readonly ACCOUNT_ROUTE = import.meta.env.VITE_ACCOUNT_ROUTE
  static readonly VISITOR_ROUTES: Route[] = import.meta.env.VITE_VISITOR_ROUTES.split(',')
  static readonly USER_FREE_ROUTES: Route[] = import.meta.env.VITE_USER_FREE_ROUTES.split(',')

  static isVisitorRoute(route: Route): boolean {
    return Routes.VISITOR_ROUTES.includes(route)
  }

  static isUserFreeRoute(route: Route): boolean {
    return Routes.USER_FREE_ROUTES.includes(route)
  }


  static redirecTo(route: Route): void {
    window.location.replace(route)
  }

  static redirectToAuth(): void {
    this.storeIntendedDestination()
    Routes.redirecTo(Routes.LOGIN_ROUTE)
    throw new Error('Access denied, redirecting to login')
  }

  static redirectToAccount(): void {
    Routes.redirecTo(Routes.ACCOUNT_ROUTE)
    throw new Error('Access denied, redirecting to login')
  }

  static redirectToMarketing(): void {
    Routes.redirecTo(Routes.MARKETING_WEBSITE)
    throw new Error('Access denied, redirecting to login/cta')
  }

  static storeIntendedDestination(url?: string): void {
    // Store the intended destination URL in sessionStorage
    // If no URL provided, use the current URL
    const destination = url || window.location.href
    sessionStorage.setItem('intendedDestination', destination)
  }

  static getIntendedDestination(): string | null {
    return sessionStorage.getItem('intendedDestination')
  }

  static clearIntendedDestination(): void {
    sessionStorage.removeItem('intendedDestination')
  }

  static redirectToPrevious(): void {
    // Check if user has an intended destination stored (from social post link)
    const intendedDestination = this.getIntendedDestination()
    if (intendedDestination) {
      this.redirecTo(intendedDestination)
      this.clearIntendedDestination() // Clear it after use
      return
    }
    
    // Default fallback: redirect to homepage
    this.redirecTo("/")
  }
}